import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=9284b954&scoped=true"
import script from "./Composer.vue?vue&type=script&lang=js"
export * from "./Composer.vue?vue&type=script&lang=js"
import style0 from "./Composer.vue?vue&type=style&index=0&id=9284b954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9284b954",
  null
  
)

export default component.exports